<p>auth0-sdk-login works!</p>
